import React from "react";

// function LocaleContext() {
//   const [locale, setLocale] = React.useState("fr");
const LocaleContext = React.createContext();
//   return LocaleContext;
// }

export default LocaleContext;
